import React, { useEffect } from "react";
import CaptchaForm from "assets/scripts/components/common/form/CaptchaForm/CaptchaForm";
import { connect } from "react-redux";
import { signUpWithQrCode } from "assets/scripts/domain/validation/validationActions";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import { defineMessages, FormattedMessage } from "react-intl";
import styles from "./SignUpToken/SignUpToken.module.less";
import MiscRepository from "assets/scripts/domain/misc/MiscRepository";
const messages = defineMessages({
    submit: {
        id: "forms.accountNew.submit",
        defaultMessage: "Continue"
    }
});
function SignUpQr(props) {
    const { referenceNumber, pin } = props.params;
    const { isRequiredCaptcha } = props;
    useEffect(() => {
        MiscRepository.trackEvent({
            event: "ScannedQRCode",
            referenceNumber: referenceNumber.toString(),
            pin: pin.toString()
        });
    }, []);
    useEffect(() => {
        if (props.loading == null && !isRequiredCaptcha) {
            props.signUpWithQrCode(referenceNumber, pin, null);
        }
    }, [props.loading, isRequiredCaptcha]);
    const isCaptchaError = props.error?.response?.status === 417
        || props.error?.response?.status === 429;
    return (<div className="wrapper">
			<div className="content mix-content_centerText">
				<StatusMessage isLoad isActive={props.loading || (props.loading == null && !isRequiredCaptcha)}/>

				{props.error != null && !isCaptchaError && (<FormattedMessage id="account.closed.message" defaultMessage="We apologize for the inconvenience but we are unable to add this account. Please contact our office at 1-877-326-8786."/>)}

				{(props.error == null || isCaptchaError) && isRequiredCaptcha && (<CaptchaForm onSubmit={captchaResponse => {
        props.signUpWithQrCode(referenceNumber, pin, captchaResponse);
    }} isBusy={props.loading ?? false} submitLabel={messages.submit} className={styles.form} hideRequiredMessage isValid force>
						{captcha => captcha}
					</CaptchaForm>)}
			</div>
		</div>);
}
export default connect((state, _ownProps) => ({
    ...state.validation.registerDirectLink,
    isRequiredCaptcha: state.auth.isRequiredCaptcha
}), {
    signUpWithQrCode
})(SignUpQr);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/SignUpQr.tsx